import type { BBSymbolLink, StorySymbols, TreeModel } from 'types/story';
import type { DesignPresetStyles, StyleAssignmentLayer } from 'common/design-tokens/preset-styles';
import { findComponentBy } from './find-component-by';
import { getSymbolModel } from './get-symbol-model';

export function getSymbolStyleLayers(
	element: TreeModel | BBSymbolLink,
	symbols: StorySymbols = {}
): StyleAssignmentLayer[] {
	const symbol = element.symbol && symbols[element.symbol.masterId];
	if (!symbol)
		return '_id' in element
			? [{ owner: 'element', styles: (element.uiConfig.componentProps.styles as DesignPresetStyles) ?? {} }]
			: [];
	const ref = element.symbol!;
	const master = ref.childId
		? findComponentBy([symbol.master], { path: '_id', value: ref.childId })?.component
		: symbol.master;
	const root = symbol.instance[ref.instanceId];
	const instance =
		ref.childId && root ? findComponentBy([root], { path: 'symbol.childId', value: ref.childId })?.component : root;
	return [
		...(master
			? [
					{
						owner: 'master' as const,
						styles: (master.uiConfig.componentProps.styles as DesignPresetStyles) ?? {},
					},
				]
			: []),
		...(instance
			? [
					{
						owner: 'instance' as const,
						styles: (instance.uiConfig.componentProps.styles as DesignPresetStyles) ?? {},
					},
				]
			: []),
	];
}

/** getSymbolModel expands a root; a child reader must keep the selected child's identity. */
export function getExpandedStyleElement(
	element: TreeModel | BBSymbolLink,
	symbols: StorySymbols = {}
): TreeModel | undefined {
	if (!element.symbol || !symbols[element.symbol.masterId]) return '_id' in element ? element : undefined;
	const root = getSymbolModel({ symbol: element.symbol }, symbols);
	if (!element.symbol.childId) return root;
	return findComponentBy([root], { path: 'symbol.childId', value: element.symbol.childId })?.component;
}
